import FilterStatus from '../../../types/report/FilterStatus';
import ReportFilter from '../../../types/report/ReportFilter';
import StatementHelper from '../../types/Functions/StatementHelper';
import SelectOption from '../../types/SelectOption';

class FilterHelper extends StatementHelper<ReportFilter> {

    getDataSourceId(filter: ReportFilter): number | null {

        return filter.dataSourceId;
    }

    getEmpty(rawDataSourceId: number): ReportFilter {

        return {
            id: null,
            dataSourceId: rawDataSourceId,
            number: 0,
            condition: null as any,
            name: '',
            businessDescription: '',
            isBespoke: false,
            bespokeCondition: '',
            errors: [],
            lastUpdatedTime: undefined,
            _internalId: 1,
            status: FilterStatus.Filter
        };
    }

    getStatusOptions(): SelectOption[] {
        const values = Object.keys(FilterStatus);

        let options = [] as SelectOption[];

        values.forEach((value: string) => {
            options.push({
                text: value,
                value,
            });
        });

        return options;
    }
}

const filterHelper = new FilterHelper();


export default filterHelper;
